import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Toolbar,
  Box,
  AppBar,
  Typography,
  Button,
  Container,
  MenuItem,
  Badge,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Asset1 from "./Asset1.png";
import NavDrawer from "./NavDrawer";
import SettingsMenu from "./SettingsMenu";
import SettingsIconCB from "./SettingsIcon";
import SessionContext, { getHomePath } from "./SessionContext";
import ClubSwitcher from "../clubs/ClubSwitcher";
//import Asset3 from './Asset3.png'

function GameTaskBar({
  pagesNav,
  displayContent,
  devPort,
  waiverNotifications,
  managerMode,
  betaMode
}) {
  let navigate = useNavigate();
  const session = useContext(SessionContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const showClubSwitcher = displayContent >= -1;
  const clubMode = displayContent === -1 ? "manager" : "player";
  function goHome() {
    if (clubMode === "player") {
      session.setClubId(session.lastManualClubId);
    }
    navigate(pagesNav.Home || getHomePath(session));
  }
  function goToPage(page) {
    if (page === "Home") {
      goHome();
      return;
    }
    navigate(pagesNav[page]);
  }
  console.log("CHECKING MODE");
  console.log(displayContent);
  //<Switch checked={darkMode} onChange={() => { setDarkMode(!darkMode) }} />
  //<a href="https://www.chukkerbook.com">
  //<img src={Asset3} width={75} height={75} sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} onClick={() => navigate('/')} />
  if (isMobile && displayContent >= -1) {
    return (
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ gap: 0.5, py: 1 }}>
            <IconButton
              onClick={() => setDrawerOpen(true)}
              aria-label="Open menu"
              data-testid="nav-drawer-button"
              sx={{ color: "white" }}
            >
              <Badge
                variant="dot"
                color="secondary"
                invisible={!waiverNotifications}
                overlap="circular"
              >
                <MenuIcon />
              </Badge>
            </IconButton>
            <IconButton
              onClick={goHome}
              aria-label="Home"
              data-testid="home-button"
              sx={{ color: "white", mr: 1 }}
            >
              <HomeOutlinedIcon />
            </IconButton>
            <ClubSwitcher mode={clubMode} devPort={devPort} placement="strip" />
          </Toolbar>
        </Container>
        <NavDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          pagesNav={pagesNav}
          waiverNotifications={waiverNotifications}
          managerMode={managerMode}
          betaMode={betaMode}
          devPort={devPort}
        />
      </AppBar>
    );
  }
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img
            src={Asset1}
            alt="Chukkerbook red logo"
            width={70}
            height={70}
            style={{ cursor: "pointer" }}
            onClick={goHome}
          />
          {showClubSwitcher && (
            <ClubSwitcher mode={clubMode} devPort={devPort} />
          )}
          {displayContent > -2 && (
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              {Object.keys(pagesNav).map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => goToPage(page)}
                  data-testid={"desktop-menu-" + page}
                >
                  <Typography textAlign="center">{page}</Typography>
                  <Badge
                    badgeContent={waiverNotifications}
                    color="secondary"
                    invisible={page !== "Players"}
                    style={{ bottom: 10 }}
                  />
                </MenuItem>
              ))}
            </Box>
          )}
          {displayContent > -2 && (
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {Object.keys(pagesNav).map((page) => (
                <Button
                  key={page}
                  onClick={() => goToPage(page)}
                  data-testid={"mobile-menu-" + page}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  {page}
                  <Badge
                    badgeContent={waiverNotifications}
                    color="secondary"
                    invisible={page !== "Players"}
                    style={{ bottom: 10 }}
                  />
                </Button>
              ))}
            </Box>
          )}
          {(displayContent === -3 ||
            displayContent === -4 ||
            displayContent === -5) && (
            <Box
              style={{ marginLeft: "auto" }}
              sx={{
                //flexGrow: 1,
                display: { xs: "flex", md: "none", position: "right" },
              }}
            >
              {Object.keys(pagesNav).map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => goToPage(page)}
                  style={{ marginLeft: "auto" }}
                  data-testid={"mobile-menu-" + page}
                >
                  <Typography textAlign="center" color="secondary">
                    {page}
                  </Typography>
                </MenuItem>
              ))}
              {/*{(displayContent <= -4 || displayContent >= -1) && (
                <SettingsIconCB setAnchorEl={setAnchorEl} />
              )}
              {(displayContent <= -4 || displayContent >= -1) && (
                <SettingsMenu
                  devPort={devPort}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                />
              )}*/}
            </Box>
          )}
          {(displayContent === -3 ||
            displayContent === -4 ||
            displayContent === -5) && (
            <Box
              style={{ marginLeft: "auto" }}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              {Object.keys(pagesNav).map((page) => (
                <Button
                  key={page}
                  onClick={() => goToPage(page)}
                  sx={{ my: 2, color: "white", display: "block" }}
                  data-testid={"desktop-menu-" + page}
                >
                  {page}
                </Button>
              ))}
            </Box>
          )}
          {displayContent === -2 && (
            <Box
              style={{ marginLeft: "auto" }}
              sx={{
                display: { xs: "flex", md: "none", position: "right" },
              }}
            />
          )}
          {displayContent === -2 && (
            <Box
              style={{ marginLeft: "auto" }}
              sx={{ display: { xs: "none", md: "flex" } }}
            />
          )}
          {(displayContent <= -4 || displayContent >= -2) && (
            <SettingsIconCB setAnchorEl={setAnchorEl} managerMode={managerMode} />
          )}
          {(displayContent <= -4 || displayContent >= -2) && (
            <SettingsMenu
              devPort={devPort}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              managerMode={managerMode}
              betaMode={betaMode}
            />
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default GameTaskBar;
